import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modena',
  templateUrl: './modena.component.html',
  styleUrls: ['./modena.component.scss'],
})
export class ModenaComponent implements OnInit {

  defecto= true;
  manual= false;

  constructor() { }

  ngOnInit() {}

  changeDefecto(){
    if(this.defecto){
      this.manual= false;
    }else if(!this.defecto){
      this.manual= true;
    }
  }

  changeManual(){
    if(this.manual){
      this.defecto= false;
    }else if(!this.manual){
      this.defecto= true;
    }
  }

}
